module.exports = __webpack_public_path__ + "img/curve_lg_2.f1824978.svg";